import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=6fe6bfa2&scoped=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js"
import style0 from "./RedefinirSenha.vue?vue&type=style&index=0&id=6fe6bfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe6bfa2",
  null
  
)

export default component.exports